/**
 * Home navigation breadcrumbs — click → route → first paint → sections ready.
 */

import { diagnosticLog } from './diagnosticLogger';

export type HomeNavPhase = 'click' | 'route' | 'first_paint' | 'sections_ready';

const flowStartMs: { current: number | null } = { current: null };

export function logHomeNavBreadcrumb(
  phase: HomeNavPhase,
  details?: Record<string, unknown>,
): void {
  try {
    const now = Date.now();
    if (phase === 'click') {
      flowStartMs.current = now;
    }
    const startedAt = flowStartMs.current;
    const elapsedMs = startedAt != null ? now - startedAt : null;

    diagnosticLog('info', 'navigation', `home-open:${phase}`, {
      phase,
      elapsed_ms: elapsedMs,
      ...details,
    });

    if (phase === 'sections_ready') {
      flowStartMs.current = null;
    }
  } catch {
    /* never propagate */
  }
}

export function resetHomeNavDiagnosticsForTests(): void {
  flowStartMs.current = null;
}
